import React from "react";

const SkiJumping = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M16.1249 2.40002C16.1249 1.07572 17.2035 0 18.5312 0C19.859 0 20.9375 1.07572 20.9375 2.40002C20.9375 3.72432 19.859 4.80004 18.5312 4.80004C17.2035 4.80004 16.1249 3.72432 16.1249 2.40002ZM5.81235 6.17148C5.81235 5.4129 6.42681 4.80004 7.18736 4.80004H14.4663C16.3054 4.80004 17.2249 7.01577 15.923 8.31007L10.2597 13.9587L9.59793 17.9059L19.6355 12.7287C20.4347 12.3172 20.9375 11.4944 20.9375 10.5987V10.2858C20.9375 9.71579 21.3973 9.25722 21.9687 9.25722C22.5402 9.25722 23 9.71579 23 10.2858V10.5987C23 12.2658 22.0676 13.7915 20.5851 14.5587L2.50373 23.8845C2.00099 24.1459 1.37793 23.9488 1.11582 23.443C0.853712 22.9373 1.05137 22.3202 1.55841 22.0587L6.54712 19.483L7.75026 12.3001C7.89205 11.4558 8.29596 10.6715 8.90183 10.0672L11.4327 7.54292H7.19166C6.4311 7.54292 5.81665 6.93006 5.81665 6.17148H5.81235Z" />
    </svg>
  );
};

export default SkiJumping;
